<script setup lang="ts">
import {CheckCircle, FileText, LayoutTemplate, Mailbox, PhoneCall} from "lucide-vue-next";

import '@/assets/styles/ablauf.css'
</script>

<template>
  <div class="ablauf">
    <section class="features">
      <div class="feature-wrapper">
        <h1>So kann Ihr Projekt ablaufen</h1>

        <div class="feature-grid">
          <!-- Schritt 1 -->
          <div class="feature-card">
            <div class="feature-icon">
              <Mailbox/>
            </div>
            <h3>1. Anfrage</h3>
            <p>
              Sie senden mir eine unverbindliche Anfrage über das Kontaktformular oder direkt über den
              Projekt-Fragebogen.
              Für konkrete Projekte empfehle ich den Fragebogen, damit ich Ihr Vorhaben direkt besser einschätzen kann.
            </p>
          </div>

          <!-- Schritt 2 -->
          <div class="feature-card">
            <div class="feature-icon">
              <PhoneCall/>
            </div>
            <h3>2. Erstgespräch</h3>
            <p>
              In einem kurzen Gespräch (ca. 10–20 Minuten) klären wir Ihre Ziele, Inhalte und den Umfang der Webseite.
              Auf Basis Ihrer Angaben erhalten Sie ein individuelles Angebot per E-Mail mit allen Leistungen und Kosten
              im Überblick.
            </p>
          </div>

          <!-- Schritt 3 -->
          <div class="feature-card">
            <div class="feature-icon">
              <FileText/>
            </div>
            <h3>3. Angebot & Projektstart</h3>
            <p>
              Auf Basis Ihrer Angaben erhalten Sie ein individuelles Angebot per E-Mail.
              Nach Ihrer Beauftragung starten wir das Projekt und Sie übermitteln mir alle Inhalte über den
              Projekt-Fragebogen (falls noch nicht ausgefüllt).
            </p>
          </div>

          <!-- Schritt 4 -->
          <div class="feature-card">
            <div class="feature-icon">
              <LayoutTemplate/>
            </div>
            <h3>4. Design & Anpassungen</h3>
            <p>
              Auf Basis Ihrer Angaben erstelle ich die Webseite mit bewährter Struktur.
              Anschließend erhalten Sie eine Vorschau und können Anpassungen mitteilen.
            </p>
          </div>

          <!-- Schritt 5 -->
          <div class="feature-card">
            <div class="feature-icon">
              <CheckCircle/>
            </div>
            <h3>5. Fertigstellung & Veröffentlichung</h3>
            <p>
              Nach Ihrer finalen Freigabe wird die Webseite veröffentlicht. Optional übernehme ich auch Hosting und
              Wartung.
            </p>
          </div>
        </div>

        <router-link :to="{ path: '/kontakt', query: { tab: 'project' } }" class="service-btn">
          Projekt anfragen
        </router-link>

      </div>
    </section>

    <!--    &lt;!&ndash; Projektfragebogen &ndash;&gt;
        <div class="feature-card questionnaire">
          <h2>Projekt-Fragebogen (sehr wichtig)</h2>
          <ul class="popup-list">
            <li>Projektinformationen: Firmenname, Branche, Ziel der Webseite</li>
            <li>Design: Logo vorhanden? Wunschfarben..</li>
            <li>Inhalte: Texte vorhanden? Bilder vorhanden? Welche Seiten werden benötigt?</li>
            <li>Technisch: Domain vorhanden? Hosting vorhanden?</li>
          </ul>
          <p>
            Dieser Fragebogen spart Ihnen und mir extrem viel Zeit und sorgt für einen reibungslosen Projektstart.
          </p>
        </div>-->

  </div>
</template>

<style scoped>

</style>